import React from "react";
import { Link } from "react-router-dom";
import { fetchAll, updateOne, deleteOne } from "actions/accessCard";
import { connect } from "react-redux";
import DeleteModal from "components/DeleteModal";
import UpdateAccessCardModal from "components/UpdateAccessCardModal";

const list = byId => Object.keys(byId).map(id => byId[id]);

const mapStateToProps = state => ({
  accessCards: list(state.accessCard.byId),
  isFetchingClient: state.accessCard.isFetching,
  isReady: list(state.accessCard.byId) && !state.accessCard.isFetching
});

const mapDispatchToProps = {
  fetchAll,
  updateOne,
  deleteOne
};

class AdminAccessCardList extends React.Component {
  componentWillMount() {
    this.props.fetchAll();
  }
  render() {
    const { accessCards, isReady } = this.props;
    if (!isReady) {
      return <div>Spinner</div>;
    }
    return (
      <div>
        <Link to="/admin/accesscard/create">
          <button className="btn btn-danger mb-2">Legg til adgangskort</button>
        </Link>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Selskap</th>
              <th scope="col">Bestillers navn</th>
              <th scope="col">Fornavn</th>
              <th scope="col">Etternavn</th>
              <th scope="col">Adgangsnivå</th>
              <th scope="col">PIN-kode</th>
              <th scope="col">Merknader</th>
              <th scope="col">Handlinger</th>
            </tr>
          </thead>
          <tbody>
            {accessCards.map(accessCard => (
              <tr key={accessCard.id}>
                <th scope="row">{accessCard.id}</th>
                <td>{accessCard.user.company}</td>
                <td>{accessCard.orderer}</td>
                <td>{accessCard.firstname}</td>
                <td>{accessCard.surname}</td>
                <td>
                  {" "}
                  <ul>
                    {accessCard.access_levels.map(({ id, name }) => (
                      <li key={`${id}`}>{name}</li>
                    ))}
                  </ul>
                </td>
                <td>{accessCard.pin}</td>
                <td>{accessCard.note}</td>
                <td>
                  <div className="btn-toolbar">
                    <UpdateAccessCardModal
                      onSubmit={this.props.updateOne}
                      title={
                        "Redigerer ID " +
                        accessCard.id +
                        " - " +
                        accessCard.name
                      }
                      accessCard={accessCard}
                    />
                    <DeleteModal
                      onDelete={this.props.deleteOne}
                      title={
                        "[" +
                        accessCard.id +
                        "] " +
                        accessCard.surname +
                        ", " +
                        accessCard.firstname
                      }
                      id={accessCard.id}
                    >
                      Adgangskort: {accessCard.surname}, {accessCard.firstname}
                    </DeleteModal>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  AdminAccessCardList
);



// WEBPACK FOOTER //
// ./src/components/AdminAccessCardList.js